/*
 * @Author: etong
 * @Date: 2021-07-07 10:39:28
 * @LastEditTime: 2022-07-08 16:26:51
 * @LastEditors: your name
 * @Description:
 * @FilePath: \oak\src\api\commonPage\commonList.js
 * Think first, Program later
 */
import request from '@/utils/request'

// 获取明细列表不分页查询
const GetList = function(data) {
  const { module = 'doc', params } = data
  return request({
    url: module + '/Query/GetList',
    method: 'post',
    data: params
  })
}

// 列表查询获取
const GetDocumentPageList = function(data) {
  const { module = 'doc', params } = data
  return request({
    url: module + '/Query/GetPageList',
    method: 'post',
    data: params
  })
}

// 导出
const ExportDocumentList = function(data) {
  const { module = 'doc', params } = data
  return request({
    url: module + '/Query/ExportList',
    // url: module + '/Documents/ExportDocumentList',
    method: 'post',
    data: params
  })
}

// 根据上游docModel查询下游选项
const GetDownstreams = function(data) {
  const { module = 'doc', params } = data
  return request({
    url: module + '/Documents/GetDownstreams',
    method: 'get',
    params
  })
}

// 根据RelationID和上游单据业务id初始化下游单据信息
const InitDownstreamDocument = function(data) {
  const { module = 'doc', params } = data
  return request({
    url: module + '/Documents/InitDownstreamDocument',
    method: 'get',
    params
  })
}

// 根据上游docModel查询下游选项
const GetQueryInfo = function(data) {
  return request({
    url: 'doc/Query/GetQueryInfo',
    method: 'post',
    data
  })
}

// 批量提交
const BatchCreateJJFlow = function(data) {
  const { module = 'doc', params } = data
  return request({
    url: module + '/Documents/BatchCreateJJFlow',
    method: 'post',
    data: params
  })
}

export default {
  BatchCreateJJFlow,
  GetDocumentPageList,
  ExportDocumentList,
  GetDownstreams,
  InitDownstreamDocument,
  GetList,
  GetQueryInfo
}
